import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  InputAdornment
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import TableCell from 'components/Table/TableCell';
import { CircularProgress, Typography, Divider } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import text from 'texts/translations';
import componentStyles from './MultiAddList.css';
import { toJS } from 'mobx';
import { get } from 'lodash';
import Translation from '../../../components/Translation/Translation';

var ObjectID = require('bson-objectid');

@inject('formDataStore')
@observer
class MultiAddList extends Component {
  constructor(props) {
    super(props);
    this.formDataStore = this.props.formDataStore;
    this.tableData = this.props.tableData;
  }

  handleChange(targetObject, rowID, targetArray, key, event) {
    this.formDataStore.assignValueToProperty(
      targetObject,
      rowID,
      targetArray,
      key,
      event.target.value
    );
  }

  changeValueOnlyNumbers(targetObject, id, targetArray, key, event) {
    console.log(event.target.value);
    if (/[^0-9 ]/.test(event.target.value)) {
      this.props.formDataStore.assignValueToProperty(id, targetArray, key, 0);
    } else {
      this.props.formDataStore.assignValueToProperty(
        targetObject,
        id,
        targetArray,
        key,
        event.target.value
      );
    }
  }

  addTableRow() {
    // State change will cause element re-render
    if (!this.tableData.isSingle) {
      this.tableData.tableDataModel._id = ObjectID.generate();
    }

    this.formDataStore.addObjectToArray(
      'customerCase',
      this.tableData.tableTargetArray,
      this.tableData.tableDataModel
    ); //add a custom id here
  }

  removeTableRow() {
    this.formDataStore.removeObjectFromArray(
      'customerCase',
      this.tableData.tableTargetArray
    ); //add a custom id here
  }

  render() {
    return (
      <Paper style={componentStyles.root}>
        <Table style={componentStyles.table}>
          <TableHead>
            <TableRow>
              {/* Create Table Head Row with col names */}
              {this.tableData.tableColHeaders.map(n => {
                return <TableCell key={n} cellContent={n} />;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {get(this.formDataStore.customerCase,
              this.tableData.tableTargetArray
            ).map((row, index) => {
              return (
                <TableRow key={index}>
                  {this.tableData.tableColKeys.map((key, _index) => {
                    if (this.tableData.keyDataTypes[key] === 'number') {
                      return (
                        <TableCell
                          key={_index}
                          cellContent={
                            <TextField
                              value={this.tableData.isSingle ? row : row[key]}
                              type={'text'}
                              onChange={e =>
                                this.changeValueOnlyNumbers(
                                  'customerCase',
                                  this.tableData.isSingle ? null : row._id,
                                  this.tableData.tableTargetArray,
                                  this.tableData.isSingle ? index : key,
                                  e
                                )
                              }
                            />
                          }
                        />
                      );
                    } else {
                      return (
                        <TableCell
                          key={_index}
                          cellContent={
                            <TextField
                              value={this.tableData.isSingle ? row : row[key]}
                              type={'text'}
                              onChange={e =>
                                this.handleChange(
                                  'customerCase',
                                  this.tableData.isSingle ? null : row._id,
                                  this.tableData.tableTargetArray,
                                  this.tableData.isSingle ? index : key,
                                  e
                                )
                              }
                            />
                          }
                        />
                      );
                    }
                  })}
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell
                component="th"
                scope="row"
                cellContent={
                  <Button
                    onClick={() => {
                      this.addTableRow('customerCase');
                    }}
                    color={'primary'}
                  >
                    <Translation>add_row</Translation>
                  </Button>
                }
              />
              {this.tableData.tableColKeys.map((key, index) => {
                if (index > 1) {
                  return <TableCell cellContent={''} />;
                }
              })}
              <TableCell
                style={{textAlign: 'right'}}
                cellContent={
                  <Button
                    onClick={() => {
                      this.removeTableRow('customerCase');
                    }}
                    color={'secondary'}
                  >
                    <Translation>remove_row</Translation>
                  </Button>
                }
              />
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
export default MultiAddList;



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/MultiAddList/MultiAddList.jsx